import React from 'react';
import PropTypes from 'prop-types';

import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';


const SkeletonTable = ({headers}) => {
    return (
        <Table size='small'>
            <TableHead sx={{ backgroundColor: 'background.default' }}>
                <TableRow>
                    {
                        headers.map((item, index) => {
                            return (
                                <TableCell key={index}>{item}</TableCell>
                            );
                        })
                    }
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    headers.map((item, index) => {
                        return (
                            <TableRow key={index}>
                                {
                                    headers.map((it, i) => {
                                        return (
                                            <TableCell key={i}><Skeleton /></TableCell>
                                        );
                                    })
                                }
                            </TableRow>
                        );
                    })
                }
            </TableBody>
        </Table>        
    );
};


SkeletonTable.propTypes = {
    headers: PropTypes.array.isRequired
};


export default SkeletonTable;